type DiscountType = 'flat' | 'percentage' | '';

// The backend requires discountType and a positive discountValue together.
export function isDiscountComplete(type: DiscountType, value: string): boolean {
    return !type || Number(value) > 0;
}
